const en = {
  aiAssistant: "AI Assistant",
  defaultMessageTitle: "Hello!",
  defaultMessageDescription: "What can we assist you with?",
  typeYourQuestion: "Type your question",
  live: "Live",
  endChat: "End Chat",
  faqs: "FAQs",
  aIAssistant: "AI Assistant",
  me: "Me",
  preselectedQuestions: "Investor FAQs",
  preselectedQuestionsDescription:
    "Select one of the following frequently asked investor questions or choose a category below. ",
  selectQuestion: "Select Question",
  surveyQuestion: "How was your experience with our Investor Assistant?",
  thisIsNotFinancial:
    "aiiro can make mistakes. More specific questions will result in better responses. Validate important information.",
  poweredBy: "Powered by ",
  byClickingHere:
    "By clicking here, I state that I have read and understood the",
  termsOfUse: "Terms of Use",
  and: "and",
  privacyPolicy: "Privacy Policy",
  cookiesPolicy: "Cookies Policy",
};
export default en;
